// extracted by mini-css-extract-plugin
export default {"container":"HowDoesItWork_container__O89qs","title":"HowDoesItWork_title__vBws8","video_container":"HowDoesItWork_video_container__qyNeD"};